<div
    class="tw-flex tw-flex-col tw-gap-[42px] tw-px-[28px] md:tw-px-[50px] lg:tw-px-[80px]"
>
    <div
        class="tw-flex tw-flex-col md:tw-flex-row lg:tw-gap-[80px] md:tw-gap-[30px] tw-gap-[30px]"
    >
        <!-- Implement Section -->
        <div
            class="tw-flex tw-flex-col lg:tw-gap-[30px] md:tw-gap-[10px] tw-gap-[20px]"
        >
            <div
                class="tw-flex tw-flex-col tw-gap-[10px] lg:tw-w-[342px] md:tw-w-[242px] tw-w-full"
            >
                <span
                    class="tw-text-[26px] tw-font-bold tw-leading-[130%] tw-text-[#303030]"
                >
                    {{ data?.title }}
                </span>
                <span
                    [innerHTML]="data?.description"
                    class="tw-text-[14px] tw-font-normal tw-leading-[22px] tw-text-[#303030] default-html"
                >
                </span>
            </div>

            <img
                [src]="data?.desktopcard_url"
                alt="Tab-1 Image"
                class="tw-object-contain tw-h-[287px] tw-w-full xl:tw-block tw-hidden"
            />
            <img
                [src]="data?.portraitcard_url || data?.desktopcard_url"
                alt="Tab-1 Image"
                class="tw-w-full tw-object-contain tw-h-[287px] xl:tw-hidden md:tw-block tw-hidden"
            />
            <img
                [src]="data?.mobilecard_url || data?.desktopcard_url"
                alt="Tab-1 Image"
                class="tw-w-full tw-object-contain tw-h-[287px] md:tw-hidden tw-block"
            />
        </div>

        <!-- Checklist Section -->
        <div class="tw-flex tw-flex-col tw-gap-[14px] tw-w-full">
            <span
                class="tw-text-[16px] tw-font-bold tw-leading-[22px] lg:tw-mt-4 md:tw-mt-4 tw-mt-0"
            >
                {{ data?.title1 }}
            </span>
            <ul
                role="list"
                class="tw-flex tw-flex-col tw-gap-[14px] tw-p-0 tw-m-0"
            >
                <li
                    *ngFor="let item of checklist"
                    class="tw-flex tw-items-start tw-gap-[14px] tw-bg-white"
                >
                    <!-- custom image / avatar -->
                    <img
                        src="assets/images/Jc3/Jc-Checklist-Item.png"
                        [alt]="item"
                        class="tw-w-[28.5px] tw-h-[28.5px] tw-rounded-md tw-object-cover tw-flex-shrink-0"
                    />

                    <!-- content -->
                    <div
                        class="tw-flex tw-flex-col tw-justify-center tw-flex-1"
                    >
                        <span
                            [innerHTML]="item"
                            class="tw-text-[14px] tw-font-normal tw-leading-[20px] default-html"
                        >
                        </span>
                    </div>
                </li>
                <li class="tw-flex tw-items-start tw-gap-[14px] tw-bg-white">
                    <!-- custom image / avatar -->
                    <img
                        src="assets/images/Jc3/Jc-Checklist-Item.png"
                        alt="item"
                        class="tw-w-[28.5px] tw-h-[28.5px] tw-rounded-md tw-object-cover tw-flex-shrink-0 tw-opacity-0"
                    />

                    <!-- content -->
                    <div
                        class="tw-flex tw-flex-col tw-justify-center tw-flex-1"
                    >
                        <span
                            [innerHTML]="data?.moreinformation"
                            class="lg:tw-text-[13px] md:tw-text-[14px] tw-text-[14px] tw-leading-[20px] tw-font-normal default-html"
                        >
                        </span>
                    </div>
                </li>
                <li
                    *ngIf="data?.photosource2"
                    class="tw-flex tw-items-start tw-gap-[14px] tw-bg-white"
                >
                    <img
                        src="assets/images/Jc3/Jc-Checklist-Item.png"
                        alt="item"
                        class="tw-w-[28.5px] tw-h-[28.5px] tw-rounded-md tw-object-cover tw-flex-shrink-0 tw-opacity-0"
                    />
                    <div
                        class="tw-flex tw-flex-col tw-gap-[10px] tw-mx-auto md:tw-m-0"
                    >
                        <img
                            [src]="data?.desktopcard2_url"
                            alt="Plan Tab Image - 1"
                            class="tw-w-full xl:tw-block tw-hidden"
                        />
                        <img
                            [src]="
                                data?.portraitcard2_url ||
                                data?.desktopcard2_url
                            "
                            alt="Plan Tab Image - 1"
                            class="tw-w-full xl:tw-hidden md:tw-block tw-hidden"
                        />
                        <img
                            [src]="
                                data?.mobilecard2_url || data?.desktopcard2_url
                            "
                            alt="Plan Tab Image - 1"
                            class="tw-w-full md:tw-hidden tw-block"
                        />
                        <div class="tw-flex tw-items-center tw-gap-1">
                            <p>Source:</p>
                            <span
                                class="tw-text-[14px]"
                                [innerHTML]="data?.photosource2"
                            >
                            </span>
                        </div>
                    </div>
                </li>
                <li
                    *ngIf="data?.photosource3"
                    class="tw-flex tw-items-start tw-gap-[14px] tw-bg-white"
                >
                    <img
                        src="assets/images/Jc3/Jc-Checklist-Item.png"
                        alt="item"
                        class="tw-w-[28.5px] tw-h-[28.5px] tw-rounded-md tw-object-cover tw-flex-shrink-0 tw-opacity-0"
                    />
                    <div
                        class="tw-flex tw-flex-col tw-gap-[10px] tw-mx-auto md:tw-m-0"
                    >
                        <img
                            [src]="data?.desktopcard3_url"
                            alt="Plan Tab Image - 1"
                            class="tw-w-full xl:tw-block tw-hidden"
                        />
                        <img
                            [src]="
                                data?.portraitcard3_url ||
                                data?.desktopcard3_url
                            "
                            alt="Plan Tab Image - 1"
                            class="tw-w-full xl:tw-hidden md:tw-block tw-hidden"
                        />
                        <img
                            [src]="
                                data?.mobilecard3_url || data?.desktopcard3_url
                            "
                            alt="Plan Tab Image - 1"
                            class="tw-w-full md:tw-hidden tw-block"
                        />
                        <div class="tw-flex tw-items-center tw-gap-1">
                            <p>Source:</p>
                            <span
                                class="tw-text-[14px]"
                                [innerHTML]="data?.photosource3"
                            >
                            </span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
<div class="tw-flex tw-flex-row tw-justify-center tw-mt-6">
    <a
        [attr.ga-event-id]="gaId"
        [attr.ga-event-category]="'JC3 Button'"
        [attr.ga-event-label]="'Download Button Click'"
        ga-track="track"
        href="/assets/documents/SFG-ESG-JumpStart-Guide-12-Sep-2025.pdf"
        target="_blank"
        class="tw-px-[23px] tw-py-[12px] tw-border tw-border-[#024B3F] tw-bg-[#024B3F] tw-rounded-[30px]"
    >
        <span
            class="tw-text-white tw-text-[14px] tw-leading-[15px] tw-font-bold tw-pointer-events-none"
            >{{ data?.cta }}</span
        >
    </a>
</div>
